import { getIsNonProductionEnvironment } from '@shared/getEnvironmentKind';

/* S3 bucket Utiq resources obfuscated endpoint name */
export const getResourcesOrigin = () =>
  getIsNonProductionEnvironment()
    ? 'https://utiq-http-resources.test.utiq-aws.net'
    : 'https://utiqcontent.com';
